import { Box, Paper, Skeleton } from '@mui/material';
import { profileCardSX, skeletonColor } from '../profileStyles';

export const ProfileHeaderSkeleton = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        ...profileCardSX,
        gridColumn: { xs: '1', md: '1 / -1' },
        padding: { xs: '18px 16px', sm: '24px 28px' },
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 2, sm: 2.5 },
      }}
    >
      <Skeleton variant="circular" width={64} height={64} sx={{ backgroundColor: skeletonColor, flexShrink: 0 }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width={90} height={16} sx={{ backgroundColor: skeletonColor }} />
        <Skeleton variant="text" width="35%" height={34} sx={{ backgroundColor: skeletonColor }} />
        <Skeleton variant="text" width="25%" height={20} sx={{ backgroundColor: skeletonColor }} />
      </Box>
    </Paper>
  );
};
